module.exports = __webpack_public_path__ + "summernote.7e263200d01fb5998c40.eot";


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/vendor/summernote/summernote.eot
// module id = ../../../../../src/vendor/summernote/summernote.eot
// module chunks = styles